import axios from 'axios';

const api = axios.create({
  baseURL: 'https://anacondacosmeticosoficial.com.br/backend/',
  // baseURL: 'http://localhost/anaconda-backend/',
});

export default api;
